import { render, staticRenderFns } from "./GeneratedLinkResultPage.vue?vue&type=template&id=41b4d42a&scoped=true&"
import script from "./GeneratedLinkResultPage.vue?vue&type=script&lang=js&"
export * from "./GeneratedLinkResultPage.vue?vue&type=script&lang=js&"
import style0 from "./GeneratedLinkResultPage.vue?vue&type=style&index=0&id=41b4d42a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b4d42a",
  null
  
)

export default component.exports